<template>
  <div>
    <ChooseRelatedProgramModal
      v-if="isShowChooseProgramModal"
      @update:customRelatedPrograms="onUpdateCustomRelatedProgram"
      :customRelatedProgramIds="program.customRelatedProgramIds"
      :onClose="onToggleChooseProgramModal" />
    <Section>
      <template v-slot:section-header>
        <h5 class="header-title m-0">รายการที่เกี่ยวข้อง</h5>
        <div class="action">
          <button class="btn btn-outline-primary" type="button" @click="onToggleChooseProgramModal">
            <i class="fa fa-plus mr-1" />
            เพิ่มรายการที่เกี่ยวข้อง
          </button>
        </div>
      </template>
      <template v-slot:section-body>
        <draggable v-model="customRelatedPrograms">
          <div class="row program-item" v-for="(program, index) in customRelatedPrograms" :key="index">
            <ListItem
              :image="program.coverImage"
              :listTitle="program.title"
              :listPrimaryInformation="getContentCategoryName(program)"
              :isDraggable="true">
              <template v-slot:button-action>
                <button class="btn btn-light btn-action" type="button" @click="onRemoveProgram(program)">
                  <i class="fa fa-trash" />
                </button>
              </template>
            </ListItem>
          </div>
        </draggable>
        <!-- <EmptyMessage v-if="playlists && !playlists.length">
          <div class="empty-message">รายการนี้ยังไม่มีเพลย์ลิสต์</div>
          <button
            class="btn btn-light mt-3"
            type="button"
            @click="onClickChoosePlaylist">
            เลือกเพลย์ลิสต์ของรายการ
          </button>
        </EmptyMessage> -->
        <EmptyMessage v-if="isShowingEmptyState">
          <div class="empty-message">ยังไม่มีรายการที่เกี่ยวข้อง</div>
        </EmptyMessage>
      </template>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import Section from '@/components/Section.vue';
import ListItem from '@/components/ListItem.vue';
import dateFormetter from '@/utils/dateFormatter';
import EmptyMessage from '@/components/EmptyMessage.vue';
import ChooseRelatedProgramModal from './ChooseRelatedProgramModal.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Section,
    ChooseRelatedProgramModal,
    draggable,
    ListItem,
    EmptyMessage,
  },
  data() {
    return {
      isShowChooseProgramModal: false,
      customRelatedPrograms: [],
    };
  },
  computed: {
    ...mapState({
      program: (state) => state.programItem.currentProgram,
    }),
    isShowingEmptyState() {
      if (!this.customRelatedPrograms) {
        return true;
      }
      if (this.customRelatedPrograms && !this.customRelatedPrograms.length) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.customRelatedPrograms = _.cloneDeep(this.program.customRelatedPrograms);
  },
  watch: {
    customRelatedPrograms(newProgram) {
      if (newProgram) {
        const customRelatedProgramIds = newProgram.map((program) => program.id);
        this.$store.dispatch('setCurrentProgram', { customRelatedPrograms: this.customRelatedPrograms, customRelatedProgramIds });
      }
    },
  },
  methods: {
    onToggleChooseProgramModal() {
      this.isShowChooseProgramModal = !this.isShowChooseProgramModal;
    },
    onUpdateCustomRelatedProgram(programs) {
      this.customRelatedPrograms = [...this.customRelatedPrograms, ...programs];
    },
    getContentCategoryName(program) {
      return _.get(program, 'contentCategory.name', '-');
    },
    onRemoveProgram(program) {
      const index = this.customRelatedPrograms.indexOf(program);
      if (index >= 0) {
        this.customRelatedPrograms.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
